import PropTypes from 'prop-types';

const GiftOption = ({ t, editMode, name, value, setValue }) => (
  <div className="gift-option" data-test-id="gift-container">
    <label className={`${editMode ? 'edit' : ''} tu-label`} htmlFor={name}>
      {t(`forms.formMessage.${name}`)}
    </label>
    {editMode ? (
      <input
        className="form-control gift-input tu-input"
        data-test-id="gift-option-input"
        type="text"
        id={name}
        value={value ?? ''}
        onChange={(e) => setValue(e.target.value)}
      />
    ) : (
      <div className="gift-text" data-test-id="gift-option-text">
        {value}
      </div>
    )}
  </div>
);

GiftOption.propTypes = {
  t: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired
};

export default GiftOption;
